import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';

import { Router, Route, Redirect, Switch, withRouter } from 'react-router-dom';

// Styles
import './App.css';

// CoreUI Icons Set
import '@coreui/icons/css/free.min.css';
// Import Font Awesome Icons Set
// import 'font-awesome/css/font-awesome.min.css';
// Import Bootstrap Icons Set
import 'bootstrap-icons/font/bootstrap-icons.css';
// Import Main styles for this application
import './scss/style.css';
import 'react-tooltip/dist/react-tooltip.css';

// Containers
import DefaultLayout from './components/root/DefaultLayout/DefaultLayout';
import { Login, TokenLogin } from './components/root/contentArea';
import { ALERT_CONFIG_VIEW, LOGIN_VIEW, STREAM_PLAYER_VIEW, TOKEN_LOGIN_VIEW } from './constants/general';
import { history } from './redux/store/configureStore';
import { ANALYTICS_API_URL, ENV } from './constants/config';

import { datadogRum } from '@datadog/browser-rum';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { setAlarm } from './redux/actions/general';

import * as browserStorage from './misc/BrowserStorageManager';
import * as sessionStore from './misc/BrowserStorageManager';
import EmailReceiverConfig from './components/root/contentArea/AlertConfig/EmailReceiverConfig';
import StreamPlayer from './components/root/contentArea/StreamPlayer/StreamPlayer';

datadogRum.init({
   applicationId: '3df511f5-b3f8-447c-b13b-73ff94d5c128',
   clientToken: 'puba4b774f508cef57dfabbfbcb4847b5b1',
   site: 'datadoghq.eu',
   service: 'metrics-dashboard',
   env: ENV || 'local-dev',
   // Specify a version number to identify the deployed version of your application in Datadog
   version: '2.22.0',
   sessionSampleRate: 100,
   sessionReplaySampleRate: 100,
   trackUserInteractions: true,
   trackResources: true,
   trackLongTasks: true,
   defaultPrivacyLevel: 'mask-user-input',
});

datadogRum.startSessionReplayRecording();

const mapStateToProps = (state) => {
   return state.general;
};

class App extends Component {
   constructor(props) {
      super(props);

      this.isAuthenticated = this.isAuthenticated.bind(this);
   }

   // check if JWT is still valid when tab got visible / active
   handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
         if (!browserStorage.isTokenStillValid()) {
            browserStorage.clear();
            history.push(`/${LOGIN_VIEW}`);
         }
      }
   };

   componentDidMount() {
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
   }

   componentWillUnmount() {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
   }

   componentDidUpdate(prevProps) {
      this.checkAlarms(prevProps);
   }

   isAuthenticated(props) {
      let userInfo = browserStorage.getUserInfo();

      if (userInfo == null) {
         const { pathname, search } = props.location;
         // console.log('pathname => ', pathname);
         // console.log('search => ', search);
         sessionStore.setSessionItem('pathname', pathname);
         sessionStore.setSessionItem('search', search);
         return false;
      }

      return browserStorage.isTokenStillValid;
   }

   checkAlarms(prevProps) {
      const routerChangeLocationComplete = prevProps.location.pathname === this.props.location.pathname; // if these are different, a location change is still going on

      const lastView = prevProps.currentView;
      const currentView = this.props.currentView;
      const loginComplete =
         lastView !== LOGIN_VIEW &&
         currentView !== LOGIN_VIEW &&
         lastView !== TOKEN_LOGIN_VIEW &&
         currentView !== TOKEN_LOGIN_VIEW &&
         this.isAuthenticated(this.props);

      const alarmType = this.props.alarm.type;
      const alarmMessage = this.props.alarm.message;
      const dispatch = this.props.dispatch;

      const triggerAlarm = alarmMessage !== '' && alarmType !== '';

      if (routerChangeLocationComplete && loginComplete && triggerAlarm)
         dispatch(setAlarm(alarmType, { message: alarmMessage }, true));
   }

   render() {
      axios.defaults.baseURL = ANALYTICS_API_URL || '';
      // Auth to the analytics backend is header-based (x-access-token), not cookie-based.
      // The backend no longer sends Access-Control-Allow-Credentials, so credentialed
      // cross-origin requests would be blocked by the browser — keep credentials off.
      axios.defaults.withCredentials = false;

      return (
         <Router history={history}>
            <ToastContainer />
            <Switch>
               <Route exact path={`/${LOGIN_VIEW}`} name='Login' component={Login} />
               <Route exact path={`/${TOKEN_LOGIN_VIEW}`} name='TokenLogin' component={TokenLogin} />
               <Route
                  exact
                  path={`/${ALERT_CONFIG_VIEW}/email`}
                  name='email'
                  render={(props) =>
                     this.isAuthenticated(props) ? (
                        <EmailReceiverConfig {...props} />
                     ) : (
                        <Redirect to={`/${LOGIN_VIEW}`} />
                     )
                  }
               />
               <Route
                  exact
                  path={`/${STREAM_PLAYER_VIEW}`}
                  name='streamPlayer'
                  render={(props) =>
                     this.isAuthenticated(props) ? <StreamPlayer {...props} /> : <Redirect to={`/${LOGIN_VIEW}`} />
                  }
               />
               <Route
                  path='/'
                  name='Home'
                  render={(props) =>
                     this.isAuthenticated(props) ? <DefaultLayout {...props} /> : <Redirect to={`/${LOGIN_VIEW}`} />
                  }
               />
            </Switch>
         </Router>
      );
   }
}

App.propTypes = {
   alarm: PropTypes.object,
   currentView: PropTypes.string,
   location: PropTypes.object,
   dispatch: PropTypes.func,
};

export default withRouter(connect(mapStateToProps)(App));
